<div class="tw-flex tw-flex-col tw-h-full tw-bg-teal-200 tw-bg-repeat-x tw-bg-top tw-overflow-y-auto"
     #scrollContainer>
  <div class="tw-flex-1 tw-pt-9 tw-flex tw-flex-col">
    <div class="tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3">
      <div class="tw-w-fit tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1">
        <img class="tw-block tw-w-[80px]"
             src="/assets/icons/cs-logo.svg"
             alt="icon" />
        <p class="tw-text-300 tw-font-normal tw-uppercase tw-font-lexend" i18n="@@welcomeToCure">Welcome to Cure</p>
      </div>
      <div class="tw-font-lexend tw-font-bold tw-text-800 tw-text-gray-800 tw-text-center tw-leading-10"
           i18n="@@journeyStartsHere"> Your journey <br> Starts here </div>
    </div>
    <div class="tw-flex-1 tw-flex tw-flex-col tw-justify-end tw-items-center">
      <img class="tw-w-60" src="https://cdn.cureskin.com/app/img/dr-charu-new-kit.png" alt="Dr Charu" />
    </div>
  </div>
  <div class="tw-flex-none tw-px-6 tw-pt-8 tw-bg-white tw-rounded-tr-5 tw-rounded-tl-5">
    <div class="tw-relative"
         [ngClass]="loginWithShiprocket ? 'tw-mb-2' : 'tw-mb-10'">
      <p
         class="tw-absolute tw-h-12 tw-flex tw-justify-end tw-pl-4 tw-items-center tw-font-body tw-text-300 tw-text-gray-800">
        +91 </p>
      @if (loginWithShiprocket) {
        <div class="tw-absolute tw-left-[42px] tw-top-[14px] tw-h-5 tw-w-px tw-bg-gray-800"></div>
      }
      <div class="tw-absolute tw-right-0 tw-h-12 tw-flex tw-justify-end tw-pr-4 tw-items-center">
        <cs-icon class="tw-h-5 tw-w-5"
                 [iconName]="'/rebranding/v1/check'"
                 [ngClass]="{'tw-animate-bounce_in_once tw-visible': isPhoneNumberValid && !mobileNumberError, 'tw-invisible': !isPhoneNumberValid || mobileNumberError}"></cs-icon>
      </div>
      <input no-copy
             class="tw-select-none tw-h-12 tw-flex tw-bg-gray-80 tw-rounded-2.5 tw-m-0 tw-w-full tw-font-body tw-text-300 tw-text-gray-800 placeholder:tw-font-body tw-border tw-border-solid tw-border-gray-300"
             [ngClass]="{'tw-border-teal-400': mobileInput?.value.toString().length === 10 && !mobileNumberError, 'tw-border-orange-500': mobileNumberError, 'tw-pl-[50px]': loginWithShiprocket, 'tw-pl-[42px]': !loginWithShiprocket}"
             #mobileInput=""
             id="phoneNumber"
             [(ngModel)]="phoneNumber"
             autocomplete="off"
             type="text"
             inputmode="numeric"
             pattern="[0-9]*"
             maxlength="10"
             autofocus="autofocus"
             (keydown)="commonUtilityHelper.acceptOnlyNumbers($event, 10)"
             (input)="onPhoneNumberChange()"
             (focus)="onInputFocus()"
             placeholder="Mobile Number"
             i18n-placeholder="@@mobileNumber" />
      <div *ngIf="mobileNumberError"
           class="tw-flex tw-mt-2"
           id="mobileNumberError">
           <img src="/assets/images/warn-err.png"
                style="height: 18px"
                alt="warning" />
           <div class="tw-text-orange-500 tw-text-300 tw-ml-1"
                i18n="@@enterValidMobileNumber">Enter a valid 10 digit mobile number.</div>
      </div>
    </div>
    @if (loginWithShiprocket) {
      <div id="shiprocketConsent"
           class="tw-flex tw-items-center tw-gap-2 tw-mb-9">
        <span class="tw-h-4 tw-w-4 tw-shrink-0 tw-flex tw-items-center tw-justify-center tw-rounded-none tw-border tw-border-solid tw-cursor-pointer"
              id="shiprocketConsentBox"
              (click)="shiprocketConsent = !shiprocketConsent"
              [ngClass]="shiprocketConsent ? 'tw-bg-teal-600 tw-border-teal-600' : 'tw-bg-white tw-border-gray-400'">
          @if (shiprocketConsent) {
            <svg viewBox="0 0 12 12"
                 fill="none"
                 class="tw-h-2.5 tw-w-2.5">
              <path d="M2.5 6.2L4.8 8.5L9.5 3.5"
                    stroke="white"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
          }
        </span>
        <span class="tw-font-body tw-text-200 tw-text-gray-800" i18n="@@fetchShippingAddressPastOrder">Fetch my shipping address based on past order</span>
      </div>
    }
    <footer class="tw-h-[160px]">
      <button csButton
              id="continueBtn"
              type="button"
              class="tw-w-full tw-mb-3 tw-relative proceed"
              [loading]="loading"
              [disabled]="!isPhoneNumberValid"
              (click)="requestOTP()"><span i18n="@@proceed">Proceed</span>
      </button>
      @if (loginWithShiprocket) {
        <div class="tw-font-body tw-text-100 tw-text-gray-500 tw-font-medium tw-tracking-[0.25px] tw-mb-2 tw-text-center"
             i18n="@@byContinuingAgreeShiprocket">By continuing, you agree to Cure's <span id="cure-terms" class="tw-text-gray-500 tw-font-bold" (click)='navigateTo("/iframe?src=https://cdn.cureskin.com/termsofservice_new.html&title=Terms%20of%20Use")'>T&amp;Cs</span>, <span id="cure-privacy" class="tw-text-gray-500 tw-font-bold" (click)='navigateTo("/iframe?src=https://cdn.cureskin.com/privacypolicy_new.html&title=Privacy%20Policy")'>Privacy Policy</span> and Shiprocket's <span id="shiprocket-terms" class="tw-text-gray-500 tw-font-bold" (click)='openExternalUrl("https://checkout.shiprocket.in/terms-conditions/")'>T&amp;Cs</span>, <span id="shiprocket-privacy" class="tw-text-gray-500 tw-font-bold" (click)='openExternalUrl("https://www.shiprocket.in/privacy-policy/my-shiprocket/")'>Privacy Policy</span></div>
      } @else {
        <div class="tw-font-body tw-text-100 tw-text-gray-500 tw-font-medium tw-tracking-[0.25px] tw-mb-2 tw-text-center"
             i18n="@@byContinuingAgree">
          <span>By continuing, you agree to</span>
          <span id="privacy-policy"
                class="tw-text-gray-500 tw-font-bold tw-mx-0.5"
                (click)='navigateTo("/iframe?src=https://cdn.cureskin.com/privacypolicy_new.html&title=Privacy%20Policy")'>Cure's Privacy Policy</span>
          <span>&</span>
          <span id="terms-of-service"
                class="tw-text-gray-500 tw-font-bold tw-ml-0.5"
                (click)='navigateTo("/iframe?src=https://cdn.cureskin.com/termsofservice_new.html&title=Terms%20of%20Use")'>Terms.</span>
        </div>
      }
      @if (loginWithShiprocket) {
        <img src="/assets/icons/poweredByShipRocket.png"
             class="tw-w-[150px] tw-mt-2 tw-mx-auto tw-mix-blend-multiply"
             alt="Powered By Shiprocket" />
      }
    </footer>
  </div>
</div>
